// ------------------------------------------------------------
//     NPＢの球団カラー設定（ライト／ダーク両対応）
//     css変数: --team-bg, --team-text
//     ダークモード変数: --dark-team-bg, --dark-team-text
// ------------------------------------------------------------
// 2026年レギュラーシーズン最終順位。セ・リーグ、パ・リーグの順。
export const TEAMS = [
	// 阪神タイガース
	{
		key: "tigers",
		shortName: "阪神",
		bgColor: "var(--tigers-bg)",                  // 通常背景
		textColor: "var(--tigers-text)",              // 通常文字色
		darkBgColor: "var(--dark-tigers-bg)",         // ダーク背景
		darkTextColor: "var(--dark-tigers-text)",     // ダーク文字色
		icon: "/images/logos_optimized/logo_tigers.webp"
	},

	// 読売ジャイアンツ
	{
		key: "giants",
		shortName: "巨人",
		bgColor: "var(--giants-bg)",
		textColor: "var(--giants-text)",
		darkBgColor: "var(--dark-giants-bg)",
		darkTextColor: "var(--dark-giants-text)",
		icon: "/images/logos_optimized/logo_giants.webp"
	},

	// DeNAベイスターズ
	{
		key: "dena",
		shortName: "DeNA",
		bgColor: "var(--dena-bg)",
		textColor: "var(--dena-text)",
		darkBgColor: "var(--dark-dena-bg)",
		darkTextColor: "var(--dark-dena-text)",
		icon: "/images/logos_optimized/logo_baystars.webp"
	},

	// 広島カープ
	{
		key: "carp",
		shortName: "広島",
		bgColor: "var(--carp-bg)",
		textColor: "var(--carp-text)",
		darkBgColor: "var(--dark-carp-bg)",
		darkTextColor: "var(--dark-carp-text)",
		icon: "/images/logos_optimized/logo_carp.webp"
	},

	// ヤクルトスワローズ
	{
		key: "swallows",
		shortName: "ヤクルト",
		bgColor: "var(--swallows-bg)",
		textColor: "var(--swallows-text)",
		darkBgColor: "var(--dark-swallows-bg)",
		darkTextColor: "var(--dark-swallows-text)",
		icon: "/images/logos_optimized/logo_swallows.webp"
	},

	// 中日ドラゴンズ
	{
		key: "dragons",
		shortName: "中日",
		bgColor: "var(--dragons-bg)",
		textColor: "var(--dragons-text)",
		darkBgColor: "var(--dark-dragons-bg)",
		darkTextColor: "var(--dark-dragons-text)",
		icon: "/images/logos_optimized/logo_dragons.webp"
	},

	// ソフトバンクホークス
	{
		key: "hawks",
		shortName: "ソフトバンク",
		bgColor: "var(--hawks-bg)",
		textColor: "var(--hawks-text)",
		darkBgColor: "var(--dark-hawks-bg)",
		darkTextColor: "var(--dark-hawks-text)",
		icon: "/images/logos_optimized/logo_hawks.webp"
	},

	// 西武ライオンズ
	{
		key: "lions",
		shortName: "西武",
		bgColor: "var(--lions-bg)",
		textColor: "var(--lions-text)",
		darkBgColor: "var(--dark-lions-bg)",
		darkTextColor: "var(--dark-lions-text)",
		icon: "/images/logos_optimized/logo_lions.webp"
	},

	// 日本ハムファイターズ
	{
		key: "fighters",
		shortName: "日本ハム",
		bgColor: "var(--fighters-bg)",
		textColor: "var(--fighters-text)",
		darkBgColor: "var(--dark-fighters-bg)",
		darkTextColor: "var(--dark-fighters-text)",
		icon: "/images/logos_optimized/logo_fighters.webp"
	},

	// オリックスバファローズ
	{
		key: "buffaloes",
		shortName: "オリックス",
		bgColor: "var(--buffaloes-bg)",
		textColor: "var(--buffaloes-text)",
		darkBgColor: "var(--dark-buffaloes-bg)",
		darkTextColor: "var(--dark-buffaloes-text)",
		icon: "/images/logos_optimized/logo_buffaloes.webp"
	},

	// 千葉ロッテ
	{
		key: "marines",
		shortName: "ロッテ",
		bgColor: "var(--marines-bg)",
		textColor: "var(--marines-text)",
		darkBgColor: "var(--dark-marines-bg)",
		darkTextColor: "var(--dark-marines-text)",
		icon: "/images/logos_optimized/logo_marines.webp"
	},

	// 楽天イーグルス
	{
		key: "eagles",
		shortName: "楽天",
		bgColor: "var(--eagles-bg)",
		textColor: "var(--eagles-text)",
		darkBgColor: "var(--dark-eagles-bg)",
		darkTextColor: "var(--dark-eagles-text)",
		icon: "/images/logos_optimized/logo_eagles.webp"
	},
];
